exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#xsExportDeliveries .xs-content {\n  overflow: auto;\n}\n", ""]);

// exports
